import React, { createContext, useState } from 'react'
import CustomSnackBar from './components/CustomSnackBar';
import CustomTutorialTour from './components/CustomTutorialTour';

export const ContextProvider = createContext(null)

const GlobalContextProvider = ({ children }) => {
    const [towerName, setTowerName] = useState("")
    const [flatNumber, setFlatNumber] = useState("")
    const [isChange, setIsChange] = useState(false)
    const [primaryUser, setPrimaryUser] = useState({})
    const [showSecondaryPermit, setShowSecondaryPermit] = useState(false)
    const [model, setModel] = useState("")
    const [selectedBrand, setSelectedBrand] = useState("")
    const [currentParking, setCurrentParking] = useState({});
    const [showLiveFeed, setShowLiveFeed] = useState(false);
    const [showVisitorLogsLiveFeed, setShowVisitorLogsLiveFeed] = useState(false);
    const [showOrganizationLiveFeed, setShowOrganizationLiveFeed] = useState(false)
    const [visibleSnackBar, setVisibleSnackBar] = useState({ value: false, vehicle_number: "", action: "" })
    const [sectionLoader, setSectionLoader] = useState(false)
    const [isActive, setIsActive] = useState(false);
    const [currentPathName, setCurrentPathName] = useState("")
    const [resetHeight, setResetHeight] = useState(false)
    const [permitDepartment, setPermitDepartment] = useState(null);
    const [isLFTag, setIsLFTag] = useState(false);
    const [rcImage, setRcImage] = useState("");
    const [parkingAllotmentLetterImage, setParkingAllotmentLetterImage] = useState("");
    const [showPermitValidityToggle] = useState(sessionStorage.getItem("show_permit_validity_toggle") === "1")
    const [hidePermitAmountDetails] = useState(sessionStorage.getItem("hide_permit_amount_details") === "1")
    const [slotName, setSlotName] = useState("");

    return (
        <ContextProvider.Provider
            value={{
                towerName,
                setTowerName,
                flatNumber,
                setFlatNumber,
                isChange,
                setIsChange,
                primaryUser,
                setPrimaryUser,
                showSecondaryPermit,
                setShowSecondaryPermit,
                model,
                setModel,
                selectedBrand,
                setSelectedBrand,
                currentParking,
                setCurrentParking,
                showLiveFeed,
                setShowLiveFeed,
                showVisitorLogsLiveFeed,
                setShowVisitorLogsLiveFeed,
                visibleSnackBar,
                setVisibleSnackBar,
                showOrganizationLiveFeed,
                setShowOrganizationLiveFeed,
                sectionLoader,
                setSectionLoader,
                isActive,
                setIsActive,
                currentPathName,
                setCurrentPathName,
                setResetHeight,
                resetHeight,
                permitDepartment,
                setPermitDepartment,
                isLFTag, setIsLFTag,
                rcImage, setRcImage,
                parkingAllotmentLetterImage, setParkingAllotmentLetterImage,
                hidePermitAmountDetails,
                showPermitValidityToggle,
                slotName,
                setSlotName
            }}
        >
            {children}
            <CustomSnackBar />
            <CustomTutorialTour/>
        </ContextProvider.Provider>
    )
}

export default GlobalContextProvider